export function addFilterStatusToFilterStatusText(displayText: string, isFilterOptionActive: boolean, filterPillText: string[]) {
    if (isFilterOptionActive) {
      filterPillText.push(` ${displayText}`);
    } else {
      const index = filterPillText.indexOf(` ${displayText}`);
      if (index > -1) {
        filterPillText.splice(index, 1);
      }
    }
  }